export default __webpack_public_path__ + "static/media/icono_x.cfcc01a6.png";